import avatar1 from '../../assets/images/main/avatar1.jpg';
import avatar2 from '../../assets/images/main/avatar2.webp';
import avatar3 from '../../assets/images/main/avatar3.webp';

export const REVIEWS = [
  {
    id: 1,
    name: 'Lisa',
    text: "Finally, an app that shows me who's actually viewing my profile! The real-time updates are amazing, and I’m hooked on checking my followers and engagement stats daily!",
    image: avatar1,
  },
  {
    id: 2,
    name: 'Jacob',
    text: 'Love tracking who unfollows me instantly! Plus, the insights on follower growth and likes are perfect for planning my content. My engagement has seriously improved!',
    image: avatar2,
  },
  {
    id: 3,
    name: 'Robert Fox',
    text: 'The insights are spot on! This app helped me identify my top fans and improve my content. My reach and engagement have skyrocketed!',
    image: avatar3,
  },
];
